import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["children", "font"];
import React, { useContext } from 'react';
import PT from 'prop-types';
import { intrinsicComponent, objectValues } from '../../utils/functions';
import { FontVariant } from '../../utils/types/typography/font-variant';
import Styled from './drawer.styles';
import DrawerContext from './drawer.context';
var DrawerItemText = intrinsicComponent(function (_ref, ref) {
  var children = _ref.children,
    font = _ref.font,
    rest = _objectWithoutProperties(_ref, _excluded);
  var _useContext = useContext(DrawerContext),
    isCollapsed = _useContext.isCollapsed;
  return /*#__PURE__*/React.createElement(Styled.ItemText, _extends({
    font: font,
    isCollapsed: isCollapsed
  }, rest, {
    ref: ref
  }), children);
});
DrawerItemText.defaultProps = {};
DrawerItemText.propTypes = {
  font: PT.oneOf(objectValues(FontVariant))
};
export default DrawerItemText;